export const TABLE_COLUMNS_DISPLAYNAME = {
  email: 'Employee email Id',
  firstName: 'First name',
  lastName: 'Last name',
  managerEmail: 'Manager email Id',
  employeeFunction: 'Function',
  designation: 'Designation',
  employeeAccesses: 'Admin access',
};

export const EMPLOYEE_ROSTER_COLUMN_KEYS = [
  'email',
  'firstName',
  'lastName',
  'managerEmail',
  'employeeFunction',
  'designation',
  'employeeAccesses',
];
